<div class="modal-header">
    <div>
        <h5 class="modal-title">Automation Unavailable</h5>
        <!-- <h5 class="text-muted">{{ itemName }}</h5> -->
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <div class="row mt-2">
        <div class="col-md-12 mx-auto">
            <p> Automatic emails are not available for clients that do not have a primary contact with an email address.</p>
        </div>
        <div class="col-md-12">
            <a routerLink="/clients/{{projectClientId}}" class="btn btn-primary w-100">Go to Client</a>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submit(1)">Continue</button>
    <button type="button" class="btn btn-secondary" (click)="submit(0)">Cancel</button>
</div>
